export default (store) => {
    store.subscribe((mutation, state) => {
        if(mutation.type == 'setUserSession'){
            console.log("VUEX/PLUGIN/UPDATE_LOCAL_USER_SESSION::UPDATED_LOCAL_STORAGE");
            window.localStorage.setItem('userSession', JSON.stringify(mutation.payload));
        }
    })
};